import { render, staticRenderFns } from "./general.vue?vue&type=template&id=410af01a&scoped=true&"
import script from "./general.vue?vue&type=script&lang=ts&"
export * from "./general.vue?vue&type=script&lang=ts&"
import style0 from "./general.vue?vue&type=style&index=0&id=410af01a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410af01a",
  null
  
)

export default component.exports